import { createFileRoute } from '@tanstack/react-router';

import { PlayScheduleStep } from '@/features/onboarding/components/steps/lf/playScheduleStep';

export const Route = createFileRoute(
  '/_protected/onboarding/_steps/play-schedule',
)({
  component: RouteComponent,
});

function RouteComponent() {
  return <PlayScheduleStep />;
}
